import React, { useEffect, useRef } from "react";
import { Layout, Carousel, Badge, Button, Row, Col } from "antd";
// import images from "./Corouselmages";
// import { ReactComponent as MicrosoftIcon } from "../../assets/images/microsofticon.svg";
// import { ReactComponent as OktaIcon } from "../../assets/images/oktaincon.svg";
// import moongyLogo from "../../assets/images/logo_moongy.png";
import "antd/dist/antd.css";
import { config } from "../../config";

const { Header, Content } = Layout;

export default function LoginPageForm() {
    const { adentis, agap2, bee, codewin, teamit, recodme, kcsit, loginPage } = config;
    /*const { clientId, tenantId, redirectUri, authority } = microsoft;*/
    const iframeRef = useRef(null);

    const goToMicrosoft = () => {
        const responseType = "code";
        let scope = '';
        const state = generateRandomState();
        let authUrl = '';
        debugger
        if (window.location.host === adentis.host) {
            scope = `api://${adentis.microsoft.clientId}/roles.read`;
            authUrl = `${adentis.microsoft.authority}${adentis.microsoft.tenantId}/oauth2/v2.0/authorize?client_id=${adentis.microsoft.clientId}&response_type=${responseType}&redirect_uri=${adentis.microsoft.redirectUri}&scope=${scope}&state=${state}`;
        }
        else if (window.location.host === agap2.host) {
            scope = `api://${agap2.microsoft.clientId}/roles.read`;
            authUrl = `${agap2.microsoft.authority}${agap2.microsoft.tenantId}/oauth2/v2.0/authorize?client_id=${agap2.microsoft.clientId}&response_type=${responseType}&redirect_uri=${agap2.microsoft.redirectUri}&scope=${scope}&state=${state}`;
        }
        else if (window.location.host === bee.host) {
            scope = `api://${bee.microsoft.clientId}/roles.read`;
            authUrl = `${bee.microsoft.authority}${bee.microsoft.tenantId}/oauth2/v2.0/authorize?client_id=${bee.microsoft.clientId}&response_type=${responseType}&redirect_uri=${bee.microsoft.redirectUri}&scope=${scope}&state=${state}`;
        }
        else if (window.location.host === codewin.host) {
            scope = `api://${codewin.microsoft.clientId}/roles.read`;
            authUrl = `${codewin.microsoft.authority}${codewin.microsoft.tenantId}/oauth2/v2.0/authorize?client_id=${codewin.microsoft.clientId}&response_type=${responseType}&redirect_uri=${codewin.microsoft.redirectUri}&scope=${scope}&state=${state}`;
        }
        else if (window.location.host === teamit.host) {
            scope = `api://${teamit.microsoft.clientId}/roles.read`;
            authUrl = `${teamit.microsoft.authority}${teamit.microsoft.tenantId}/oauth2/v2.0/authorize?client_id=${teamit.microsoft.clientId}&response_type=${responseType}&redirect_uri=${teamit.microsoft.redirectUri}&scope=${scope}&state=${state}`;
        }
        else if (window.location.host === recodme.host) {
            scope = `api://${recodme.microsoft.clientId}/roles.read`;
            authUrl = `${recodme.microsoft.authority}${recodme.microsoft.tenantId}/oauth2/v2.0/authorize?client_id=${recodme.microsoft.clientId}&response_type=${responseType}&redirect_uri=${recodme.microsoft.redirectUri}&scope=${scope}&state=${state}`;
        }
        else if (window.location.host === kcsit.host) {
            scope = `api://${kcsit.microsoft.clientId}/roles.read`;
            authUrl = `${kcsit.microsoft.authority}${kcsit.microsoft.tenantId}/oauth2/v2.0/authorize?client_id=${kcsit.microsoft.clientId}&response_type=${responseType}&redirect_uri=${kcsit.microsoft.redirectUri}&scope=${scope}&state=${state}`;
        }
        window.location.href = authUrl;
    };

    const goToOKta = () => {
        const responseType = "code";
        const scope = "openid profile email";
        const state = generateRandomState();
        let authUrl = '';
        if (window.location.host === adentis.host)
            authUrl = `${adentis.okta.issuer}/v1/authorize?client_id=${adentis.okta.clientId}&response_type=${responseType}&redirect_uri=${adentis.okta.redirectUri}&scope=${scope}&state=${state}`;
        else if (window.location.host === agap2.host)
            authUrl = `${agap2.okta.issuer}/v1/authorize?client_id=${agap2.okta.clientId}&response_type=${responseType}&redirect_uri=${agap2.okta.redirectUri}&scope=${scope}&state=${state}`;
        else if (window.location.host === bee.host)
            authUrl = `${bee.okta.issuer}/v1/authorize?client_id=${bee.okta.clientId}&response_type=${responseType}&redirect_uri=${bee.okta.redirectUri}&scope=${scope}&state=${state}`;
        else if (window.location.host === codewin.host)
            authUrl = `${codewin.okta.issuer}/v1/authorize?client_id=${codewin.okta.clientId}&response_type=${responseType}&redirect_uri=${codewin.okta.redirectUri}&scope=${scope}&state=${state}`;
        else if (window.location.host === teamit.host)
            authUrl = `${teamit.okta.issuer}/v1/authorize?client_id=${teamit.okta.clientId}&response_type=${responseType}&redirect_uri=${teamit.okta.redirectUri}&scope=${scope}&state=${state}`;
        else if (window.location.host === recodme.host)
            authUrl = `${recodme.okta.issuer}/v1/authorize?client_id=${recodme.okta.clientId}&response_type=${responseType}&redirect_uri=${recodme.okta.redirectUri}&scope=${scope}&state=${state}`;
        else if (window.location.host === kcsit.host)
            authUrl = `${kcsit.okta.issuer}/v1/authorize?client_id=${kcsit.okta.clientId}&response_type=${responseType}&redirect_uri=${kcsit.okta.redirectUri}&scope=${scope}&state=${state}`;
        window.location.href = authUrl;
    };
    function generateRandomState() {
        const array = new Uint32Array(10);
        window.crypto.getRandomValues(array);
        return Array.from(array, (dec) => dec.toString(16)).join("");
    }
    useEffect(() => {
        const iframe = iframeRef.current;
        const handleIframeLoad = () => {
            // iframe.style.height =
            //   iframe.contentWindow.document.body.scrollHeight + "px";
        };

        const handleMessage = (event) => {
            if (event.origin !== loginPage) {
                return;
            }
            if (event.data.id === "microsoft") {
                goToMicrosoft();
            } else if (event.data.id === "okta") {
                goToOKta();
            }
        };

        window.addEventListener("message", handleMessage);
        iframe.addEventListener("load", handleIframeLoad);

        return () => {
            window.removeEventListener("message", handleMessage);
            iframe.removeEventListener("load", handleIframeLoad);
        };
    }, []);
    return (
        <>
            <div style={{ height: "100vh", margin: 0, padding: 0 }}>
                <iframe
                    ref={iframeRef}
                    src={loginPage}
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        margin: 0,
                        padding: 0,
                        display: "block",
                    }}
                ></iframe>
            </div>
        </>

        // <Layout style={{ minHeight: "100vh" }}>
        //   <Row style={{ width: "100%" }}>
        //     <Col
        //       span={10}
        //       style={{
        //         paddingLeft: "50px",
        //         paddingTop: "20px",
        //         paddingRight: "50px",
        //         paddingBottom: "40px",
        //         backgroundImage:
        //           "linear-gradient(#37BABF 0.14285714em, transparent 0.14285714em), linear-gradient(to right, #37BABF 0.14285714em, #2DB7BC 0.14285714em)",
        //         border: "none",
        //         boxShadow: "none",
        //       }}
        //     >
        //       <Header style={{ background: "none", padding: 0 }}>
        //         <img src={moongyLogo} alt="Logo" style={{ float: "left" }} />
        //         <div style={{ float: "right" }}>
        //           <Badge
        //             count="EN"
        //             style={{
        //               marginRight: "10px",
        //               backgroundColor: "transparent",
        //               fontSize: "16px",
        //               border: "none",
        //             }}
        //           />
        //           <Badge
        //             count="ES"
        //             style={{
        //               marginRight: "10px",
        //               backgroundColor: "transparent",
        //               fontSize: "16px",
        //               border: "none",
        //             }}
        //           />
        //           <Badge
        //             count="FR"
        //             style={{
        //               marginRight: "10px",
        //               backgroundColor: "transparent",
        //               fontSize: "16px",
        //               border: "none",
        //             }}
        //           />
        //           <Badge
        //             count="PT"
        //             style={{
        //               backgroundColor: "#ffffff",
        //               color: "#37BABF",
        //               fontSize: "16px",
        //               border: "none",
        //             }}
        //           />
        //         </div>
        //       </Header>
        //       <Content style={{ marginTop: "50px" }}>
        //         <div style={{ textAlign: "left" }}>
        //           <h1>Minds on the move</h1>
        //           <h3 style={{ color: "white", paddingLeft: "0px" }}>
        //             We work hard and play hard at Moongy.
        //           </h3>
        //           <p style={{ color: "white" }}>
        //             Let's finish strong and celebrate our unique culture of
        //             creativity, curiosity, and empathy.
        //           </p>
        //         </div>

        //         <div style={{ textAlign: "left", marginTop: "20px" }}>
        //           <div>
        //             <Button
        //               type="default"
        //               onClick={goToMicrosoft}
        //               icon={
        //                 <MicrosoftIcon
        //                   style={{
        //                     width: "20px",
        //                     height: "20px",
        //                     marginRight: "4px",
        //                   }}
        //                 />
        //               }
        //               style={{
        //                 marginBottom: "20px",
        //                 width: "50%",
        //                 textAlign: "left",
        //                 height: "40px",
        //               }}
        //             >
        //               Sign in with Microsoft
        //             </Button>
        //           </div>
        //           <div>
        //             <Button
        //               type="default"
        //               icon={
        //                 <OktaIcon
        //                   style={{
        //                     width: "20px",
        //                     height: "20px",
        //                     marginRight: "4px",
        //                   }}
        //                 />
        //               }
        //               style={{ width: "50%", textAlign: "left", height: "40px" }}
        //             >
        //               Sign in with Okta
        //             </Button>
        //           </div>
        //         </div>
        //       </Content>
        //     </Col>
        //     <Col span={14}>
        //       <Carousel
        //         autoplay={true}
        //         effect="fade"
        //         autoplaySpeed={10000}
        //         dots={false}
        //       >
        //         {images.map((src, index) => (
        //           <div key={index}>
        //             <img
        //               src={src}
        //               alt={`Slide ${index + 1}`}
        //               style={{ width: "100%", height: "100vh", objectFit: "cover" }}
        //             />
        //           </div>
        //         ))}
        //       </Carousel>
        //     </Col>
        //   </Row>
        // </Layout>
    );
}
